import { LinearProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import 'assets/css/react_draft_wysiwyg.css';
import FilterSortPaginationContextComponent from "context/FilterSortPaginationContext";
import { PermissionsContext } from "context/PermissionsContext";
import { signOut, useUserDispatch, useUserState } from "context/UserContext";
import React, { Suspense, useContext, useEffect } from "react";
import { IconContext } from "react-icons";
import { HashRouter, Redirect, Route, Switch, useHistory } from "react-router-dom";
import { messageReceive } from "utils";
import '../global-styles.css';
import '../print.css';

//const Code = React.lazy(() => import('pages/login/Code'));
const ChangePassword = React.lazy(() => import('pages/login/ChangePassword'));
const ForgetPasswordCaptcha = React.lazy(() => import('pages/login/ForgetPasswordCaptcha'));
const Login = React.lazy(() => import('pages/login'));
const Error = React.lazy(() => import('pages/error'));
const Layout = React.lazy(() => import('./layout/layout'));
const ValidateCguTerms = React.lazy(() => import('pages/cgu/ValidateCguTerms'));
var diff = 1;
var count = 0;
var timeoutID;

const LayoutWithFilterSortPaginationContext = () => {
  return <FilterSortPaginationContextComponent><Layout /></FilterSortPaginationContextComponent>
}

// //  we need to use different instance of axios because the current one header is `Bearer ${accessToken}`;
// const newInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
//   headers: {
//     Accept: "application/json",
//     "Authorization": "Basic T0F1dGgyV2ViVXNlcjpzZWNyZXQ=",
//   },
// });

function PrivateRoute({ component: Component, ...rest }) {

  // global
  const { isAuthenticated, user, inactivePeriodLimit } = useUserState();
  const { addUserPermissions } = useContext(PermissionsContext);
  const history = useHistory();
  const userDispatch = useUserDispatch();

  useEffect(() => {
    addUserPermissions(user);
  }, [user]);

  useEffect(() => {
    var time;
    if (isAuthenticated) {
      // use window event in react 
      // use window.onstorage unstead of window.on('storage', messageReceive);

      if (window) {
        window.onstorage = messageReceive;
      }


      // Besoin 1 
      // if inactivePeriodLimit is defined =>  logout if user is inactive f
      //  we can do it with this simple way bellow otherwise we have to install package for running idle javascript API 
      // https://blog.bitsrc.io/how-to-implement-idle-timeout-in-react-830d21c32942
      //  wen can also install https://github.com/mozilla/webextension-polyfill to enable all javascript API
      if (inactivePeriodLimit && inactivePeriodLimit != 0) {
        // window.onload = resetTimer;
        resetTimer()
        // DOM Events
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;
        function resetTimer() {
          // console.log("resetTimer", inactivePeriodLimit);
          clearTimeout(time);
          time = setTimeout(() => signOut(userDispatch, history), Number(inactivePeriodLimit) * 60 * 1000)
        }
      }

    }
    return () => {
      clearTimeout(time);
    }
  }, [inactivePeriodLimit])



  // Besoin 2 : disconnect before 30 second of token expiration not after getting anauthorized 401 request
  //  Besoin 3 : ask for refresh token when token is expired then finally disconnect before 30  of expiration
  // if (isAuthenticated) {
  //   var t1 = new Date(jwtDecode(localStorage.getItem("accessToken")).exp * 1000);
  //   var t2 = new Date();
  //   var dif = t1.getTime() - t2.getTime();
  //   // dif in seconds - 30s
  //   var Seconds_from_T1_to_T2 = dif -30000;
  //   window.clearTimeout(timeoutID);
  //   console.log("dif in seconds", Seconds_from_T1_to_T2);
  //   timeoutID = setTimeout(() =>
  //     // Besoin 1
  //     signOut(userDispatch, history)
  //     // Besoin 2
  //     //         newInstance
  //     // .post("/uaa/oauth/token", { refreshToken: localStorage.getItem("refresh_token"), grantType: "refresh_token" })
  //     // .then((r) => {
  //     //   console.log("/uaa/oauth/token is ", r.data.expires_in);
  //     //   localStorage.setItem("accessToken", r.data.access_token);
  //     //   localStorage.setItem("refreshToken", r.data.refreshToken);
  //     //   if(r.data?.expires_in>30)
  //     //   {
  //     //     // window.location.reload(false)
  //     //   }
  //     //   else{
  //     //     signOut(userDispatch, history)
  //     //   }

  //     // }).catch(()=>{
  //     //   signOut(userDispatch, history)
  //     // })
  //     , Seconds_from_T1_to_T2)
  // }

  // const themeDispatch = useThemeDispatch();



  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthenticated) {
          if (!diff && !count) {
            count++;
            return (
              <Redirect
                to={{
                  pathname: "/app/password/changePassword",
                  state: {
                    from: props.location,
                  },
                }}
              />
            )
          }
          if (JSON.parse(localStorage.getItem("cguToValidateTest"))) return (
            <Redirect
              to={{
                pathname: '/app/terms-conditions'
              }}
            />
          )
          return <Component {...props} />
        }
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: props.location,
              },
            }}
          />
        )
      }}
    />
  );
};

function PublicRoute({ component, ...rest }) {
  const { isAuthenticated } = useUserState();
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/",
            }}
          />
        ) : (
          React.createElement(component, props)
        )
      }
    />
  );
}

function App() {

  const iconClasses = makeStyles(() => ({ root: { marginLeft: 0, marginRight: 6 } }))()
  return (
    <IconContext.Provider value={{ size: "1rem", className: iconClasses.root }}>
      <HashRouter>
        <Suspense fallback={<LinearProgress color="secondary" />}>
          <Switch>
            <Route exact path="/" render={() => diff == 0 && count == 0 ? (<Redirect to="/app/password/changePassword" />) : (<Redirect to="/app/dashboard" />)} />
            <Route
              exact
              path="/app"
              render={() => diff == 0 && count == 0 ? (<Redirect to="/app/password/changePassword" />) : (<Redirect to="/app/dashboard" />)}
            />
            <Route path="/app/terms-conditions" exact component={ValidateCguTerms} />
            <PublicRoute path="/forgetPasswordCaptcha" component={ForgetPasswordCaptcha} />
            {/*<PublicRoute path="/Code" component={Code} /> */}
            <PublicRoute path="/ChangePassword" component={ChangePassword} />
            <PrivateRoute
              path="/app"
              component={LayoutWithFilterSortPaginationContext}
            />
            <PublicRoute path="/login" component={Login} />
            <Route component={Error} />
          </Switch>
        </Suspense>
      </HashRouter>
    </IconContext.Provider>
  );

  // #######################################################################
}
export default (App);
